export const getDefaultState = () => ({
  products: [],
  category: [],
  articles: [],
  aggregations: [],
  productSort: null,
  productsTotalCount: 0,
  productsTotalPages: 0,
  perPage: 10,
  isPending: false,
  filters: {
    products: true,
    categories: true,
    articles: true,
  },
  query: '',
  isClickedFromHeaderSearch: false,
})

export const state = () => ({
  ...getDefaultState(),
})
